export default {
  pageStyle: {
    display: 'inline-block',
    boxSizing: 'border-box',
    lineHeight: '32px',
    width: '100%',
    padding: '0 20px',
    fontSize: '14px'
  },

  leftStyle: {
    display: 'inline-block',
  },

  rightStyle: {
    float: 'right',
  },

  pageSizeStyle: {
    current: {
      color: '#4196fc'
    },
    common: {
      cursor: 'pointer'
    }
  }
};



// WEBPACK FOOTER //
// ./src/Components/Pagination/style.js